import { Flex, Image, MantineSize } from '@mantine/core';

import logo from 'assets/logo-transparent.svg';

import Text from './text';

interface IEmptyMessage {
  message: string;
  size?: MantineSize;
  newVersion?: boolean;
  marginTop?: number;
}

const EmptyMessage = ({
  message,
  size = 'md',
  newVersion = false,
  marginTop = 40,
}: IEmptyMessage) =>
  newVersion ? (
    <Flex pos="relative" w={300} h={200} justify="center" m="0 auto" mb={40} mt={marginTop}>
      <Image src={logo} style={{ objectFit: 'contain' }} pos="absolute" w={300} h={200} />

      <Flex align="center" mt={60} w={'auto'}>
        <Text size={size} ta="center" fz={16} fw={500} c="#323343">
          {message}
        </Text>
      </Flex>
    </Flex>
  ) : (
    <Text size={size} ta={'center'} p={'md'}>
      {message}
    </Text>
  );

export default EmptyMessage;
